import { Component, OnInit } from "@angular/core";
import { FormGroup, ReactiveFormsModule } from "@angular/forms";
import { FieldConfig } from "../../../interfaces/field.interface";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { TranslateModule } from "@ngx-translate/core";
@Component({
  selector: "app-select",
  template: `
    <ion-item [formGroup]="group" lines="none">
      <ion-select
        labelPlacement="stacked"
        interface="action-sheet"
        placeholder="{{ 'Selecione' | translate }}"
        cancelText="{{ 'Cancelar' | translate }}"
        okText="{{ 'Confirmar' | translate }}"
        [formControlName]="field.name"
      >
        <div slot="label">
          {{ field.label ? (field.label | translate) : "" }}
          <span *ngIf="field.validations && field.validations[0]?.name === 'required'" class="danger">*</span>
        </div>
        <ion-select-option *ngFor="let item of field.options" [value]="+item.id">
          {{ item.label | translate }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <div class="validation-errors">
      <ng-container *ngFor="let validation of field.validations">
        <div class="error-message" *ngIf="group.get(field.name)?.invalid && group.get(field.name)?.dirty">
          {{ "Campo Obrigatório" | translate }}
        </div>
      </ng-container>
    </div>
  `,
  styles: [
    `
      ion-item {
        --inner-border-width: 0;
        padding: 0;
        margin: 0 20px;
      }

      ion-select {
        font-size: 14px;
        max-width: 100%;
        padding: 0;
        color: #787486;
      }

      ion-select::part(label) {
        font-size: 1.3rem;
        color: black;
        margin-bottom: 0.5rem;
      }

      .error-message {
        padding-bottom: 10px !important;
        font-size: 12px !important;
      }

      .validation-errors {
        margin-left: 35px;
      }
    `,
  ],
  standalone: true,
  imports: [TranslateModule, IonicModule, ReactiveFormsModule, CommonModule],
})
export class SelectComponent implements OnInit {
  field: FieldConfig;
  group: FormGroup;
  constructor() {}
  ngOnInit() {}
}
